/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-01 17:12:05
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-02-01 15:46:55
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\api\medicalInquirie.js
 */
import req from '@/utils/req.js'


//问诊配置右侧列表
export function termListData(params) {
    return req.post("/admin/inquiry-config/page", params);
}
//问诊配置左侧树
export function apiLabel_leftData(params) {
    return req.post("/admin/open-department/classifyByHospital", params);
}
// export function detailByRefId(params) {
//     return req.get('/admin/inquiry-config/detail', params);
// }
export function detailByRefId(databaseId) {
    return req.get(`/admin/inquiry-config/${databaseId}`);
}
// export function detailByRefId(databaseId) {
//     return request.get(`/admin/label-database/quote/${databaseId}`)
// }
//标签启用停用
// export function apiLabel_enable(params) {
//     return request.put(`/admin/label-database/updateStatus/${params}`)
// }
//编辑分类
export function update(params) {
    return req.put("/admin/inquiry-config", params)
}


export function pageList(params) { //首页配置列表
    return req.post("/admin/app-banner/page", params)
}

export function getStrategicDiseaseAndWechat(databaseId) { //
    return req.get(`/patient/disease-following/getStrategicDiseaseAndWechat`);
}

export function getStrategicDisease(params) { //
    return req.get(`/admin/disease-type`);
}

export function wechatApp(databaseId) { //获取终端名称
    return req.get(`/admin//wechat-app`);
}

// 获取终端名称-新
export function wechatAppNew() {
    return req.get(`/biz/app-banner/getBannerClient`);
}

export function wechatBanner(params) { //新增banner
    return req.post("/admin/app-banner", params)
}
export function wechatBannerEdit(params) { //编辑banner
    return req.put("/admin/app-banner", params)
}

export function setTop(params) { //置顶
    return req.put(`/admin/app-banner/setTop?id=${params.id}`)
}

export function setStatus(params) { //启用，禁用
    return req.put(`/admin/app-banner/setStatus?id=${params.id}`)
}
export function deleteBanner(params) {
    return req.delete(`/admin/app-banner/${params.id}`);
}










